import React, { useState, useMemo, useContext } from 'react';
import axios from 'axios';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { useParams, useNavigate } from 'react-router-dom';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { ToastContext } from '../../../../context/ToastContext';
import ConfirmModal from '../../../Reusable_Components/ConfirmModal';
import useDetailFetch from '../../../../hooks/useDetailFetch';

const SingleQuoteProductDetails = () => {
  const { productId } = useParams();
  const navigate = useNavigate();
  const { showToast } = useContext(ToastContext);

  const decodedId = productId ? atob(productId) : productId;
  const id = decodedId.replace(/\D/g, '');
  const [showDelete, setShowDelete] = useState(false);

  const url = id ? `${API_DOMAIN}${API_ROUTES['quoteProduct']}${id}/` : null;
  const { data: details, loading } = useDetailFetch(url);

  const columns = useMemo(() => {
    if (!details) return null;
    const excluded = ['id', 'created_at', 'updated_at'];
    return Object.keys(details)
      .filter(c => !excluded.includes(c))
      .map(c => ({ label: c.charAt(0).toUpperCase() + c.slice(1), field: c }));
  }, [details]);

  const handleDelete = async () => {
    try {
      await axios.delete(API_DOMAIN + API_ROUTES['quoteProduct'] + id + '/', { headers });
      showToast('Product deleted successfully', 'success');
      navigate('/quote/product/list');
    } catch (error) {
      console.error('Error deleting product:', error);
      showToast('Error deleting product', 'error');
    }
  };

  return (
    <div>
      <SingleItemDetailTemplate
        details={details}
        columns={columns}
        loading={loading}
        entityName="Product"
        listPath="/quote/product/list"
        editPath={`/quote/product/input/${btoa(id)}`}
        onDelete={() => setShowDelete(true)}
      />
      <ConfirmModal
        show={showDelete}
        title="Delete Product"
        message="Are you sure you want to delete this product?"
        onConfirm={handleDelete}
        onCancel={() => setShowDelete(false)}
      />
    </div>
  );
};

export default SingleQuoteProductDetails;
